export enum FrequencyType {
  Weekly = "WEEKLY",
  BiWeekly = "BI_WEEKLY",
  SemiMonthly = "SEMI_MONTHLY",
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
  Annually = "ANNUALLY",
  FourFourFive = "FOUR_FOUR_FIVE"
}
